import type { CampaignUpsertInput } from '@/lib/campaigns'

export type CampaignEditCarouselSnapshotItem =
  | { kind: 'existing'; id: number }
  | { kind: 'new'; key: string }

export type CampaignEditSnapshotInput = {
  form: CampaignUpsertInput
  carouselItems: CampaignEditCarouselSnapshotItem[]
  totalNumbersMode: 'preset' | 'custom' | 'donation'
  isDonationOnlyCampaign: boolean
}

function stripFileFieldsFromForm(form: CampaignUpsertInput): Record<string, unknown> {
  const scalarForm: Record<string, unknown> = { ...form }
  delete scalarForm.main_image
  delete scalarForm.public_share_image
  delete scalarForm.regulation_pdf
  delete scalarForm.certificate_pdf
  delete scalarForm.carousel_images
  delete scalarForm.template3_hero_background
  delete scalarForm.template3_about_image
  delete scalarForm.template3_advantage_image_1
  delete scalarForm.template3_advantage_image_2
  delete scalarForm.template3_advantage_image_3
  return scalarForm
}

export function toCampaignEditCarouselSnapshot(
  items: Array<{ kind: 'existing'; id: number } | { kind: 'new'; key: string }>
): CampaignEditCarouselSnapshotItem[] {
  return items.map((item) =>
    item.kind === 'existing' ? { kind: 'existing', id: item.id } : { kind: 'new', key: item.key }
  )
}

export function serializeCampaignEditSnapshot(input: CampaignEditSnapshotInput): string {
  return JSON.stringify({
    form: stripFileFieldsFromForm(input.form),
    carousel: input.carouselItems,
    totalNumbersMode: input.totalNumbersMode,
    isDonationOnlyCampaign: input.isDonationOnlyCampaign,
  })
}

export function hasCampaignEditChanges(
  current: CampaignEditSnapshotInput,
  savedSnapshot: string,
  hasPendingFileUploads: boolean
): boolean {
  if (hasPendingFileUploads) {
    return true
  }

  return serializeCampaignEditSnapshot(current) !== savedSnapshot
}
